module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av355-3c9902f899415e83542d01484c324831.jpg";